import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Row, Col, Button, Flex, Space, Input, Anchor, Radio, DatePicker, FloatButton, InputNumber, Modal, Divider, notification, ConfigProvider } from 'antd';
import { Text } from '../../Atomics/Text';
import { Widget } from "../../Atomics/Widget";
import { SelectAtomic } from "../../Atomics/SelectAtomic";
import Spinner from "../../Atomics/Spinner";
import { useAuthContext } from "../../../../contexts/AuthContext";

export const LoadDiagram = ({ dataToFilter, loadDiagramRef, hasLoadDiagramData, isLoadDiagramLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { checkToken } = useAuthContext();

  const [selectPotencyType, setSelectPotencyType] = useState([
    { value: 'Potencia Ativa', label: t('activePotency') },
    { value: 'Potencia Reativa Indutiva', label: t('reactiveIndutivePotency') },
    { value: 'Potencia Reativa Capacitiva', label: t('reactiveCapacitivePotency') }
  ]);
  const [dataLoadConsumption, setDataLoadConsumption] = useState(null);
  const [loadPotencyFilter, setLoadPotencyFilter] = useState(t('activePotency'));
  const [loadConsumptionLoader, setLoadConsumptionLoader] = useState(false);

  const {
    data: loadConsumptionData,
    isLoading: loadConsumptionIsLoading,
    refetch: refetchLoadConsumptionData
  } = useFetch(query.path.detailLoadingDiagrams, 'getDetailLoadingDiagrams',
    { id: id, filters: JSON.stringify(dataToFilter), energyType: loadPotencyFilter, language: i18next.resolvedLanguage });

  useEffect(() => {
    isLoadDiagramLoading(loadConsumptionIsLoading)
  }, [loadConsumptionIsLoading]);

  useEffect(() => {
    if (loadConsumptionData?.data) {
      setDataLoadConsumption(loadConsumptionData?.data)
      setLoadConsumptionLoader(false)
      hasLoadDiagramData(loadConsumptionData?.data)
    }
  }, [loadConsumptionData]);

  useEffect(() => {
    hasLoadDiagramData(null)
    setLoadConsumptionLoader(true)
    refetchLoadConsumptionData()
  }, [loadPotencyFilter, dataToFilter]);

  function handleSelectLoadDiagram(value) {
    checkToken();//Validate token
    setLoadPotencyFilter(value)
  };

  return (
    <Flex id='Load Diagrams' className='ant-anchors-content-item' gap={32} vertical="true">
      <Row>
        <Col span={20}>
          <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('loadDiagrams')}</Text>
        </Col>
        <Col span={4}>
          {loadConsumptionLoader
            ? <Flex justify='center'><Spinner stroke="green" size='36px' /></Flex>
            : <SelectAtomic optionsData={selectPotencyType} defaultValue={loadPotencyFilter} handleOptionsChange={handleSelectLoadDiagram} fullWidth={true} />
          }

        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Flex gap={16} vertical="true">
            <Widget data={{
              height: '150px',
              background: 'white',
              title: t('daysOfWeek'),
              charts: [{
                cols: 12,
                title: t('pickPower'),
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                data: dataLoadConsumption?.weekday?.potencyTop
              },
              {
                cols: 12,
                title: t('averagePower'),
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                data: dataLoadConsumption?.weekday?.potencyAverage
              }]
            }} />
            <Widget data={{
              height: '150px',
              background: 'white',
              title: t('saturdayAndSunday'),
              charts: [{
                cols: 12,
                title: t('pickPower'),
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                data: dataLoadConsumption?.weekend?.potencyTop
              },
              {
                cols: 12,
                title: t('averagePower'),
                chartType: 'bigNumberChart',
                chartId: 'bigNumberChartOne',
                data: dataLoadConsumption?.weekend?.potencyAverage
              }]
            }} />
          </Flex>
        </Col>
        <Col span={16}>
          <div ref={loadDiagramRef}>
            <Widget data={{
              height: '316px',
              background: 'white',
              title: t('loadDiagrams'),
              charts: [{
                chartType: 'mixedLineColumnChartApex',
                chartId: 'mixBarChartLineThree',
                data: dataLoadConsumption?.potency
              }]
            }} /></div>
        </Col>
      </Row>
    </Flex>
  )
}